__turbopack_context__.v({
  "accountLink": "public-site-module__XXtH1q__accountLink",
  "actions": "public-site-module__XXtH1q__actions",
  "apiHero": "public-site-module__XXtH1q__apiHero",
  "apiOrb": "public-site-module__XXtH1q__apiOrb",
  "article": "public-site-module__XXtH1q__article",
  "articleGrid": "public-site-module__XXtH1q__articleGrid",
  "card": "public-site-module__XXtH1q__card",
  "chips": "public-site-module__XXtH1q__chips",
  "code": "public-site-module__XXtH1q__code",
  "container": "public-site-module__XXtH1q__container",
  "definition": "public-site-module__XXtH1q__definition",
  "downloadHero": "public-site-module__XXtH1q__downloadHero",
  "empty": "public-site-module__XXtH1q__empty",
  "eyebrow": "public-site-module__XXtH1q__eyebrow",
  "faq": "public-site-module__XXtH1q__faq",
  "faqList": "public-site-module__XXtH1q__faqList",
  "footer": "public-site-module__XXtH1q__footer",
  "footerLegal": "public-site-module__XXtH1q__footerLegal",
  "guideBanner": "public-site-module__XXtH1q__guideBanner",
  "heading": "public-site-module__XXtH1q__heading",
  "heroCopy": "public-site-module__XXtH1q__heroCopy",
  "heroVideo": "public-site-module__XXtH1q__heroVideo",
  "navigation": "public-site-module__XXtH1q__navigation",
  "note": "public-site-module__XXtH1q__note",
  "os": "public-site-module__XXtH1q__os",
  "pill": "public-site-module__XXtH1q__pill",
  "primary": "public-site-module__XXtH1q__primary",
  "prompt": "public-site-module__XXtH1q__prompt",
  "result": "public-site-module__XXtH1q__result",
  "search": "public-site-module__XXtH1q__search",
  "secondary": "public-site-module__XXtH1q__secondary",
  "section": "public-site-module__XXtH1q__section",
  "sectionHead": "public-site-module__XXtH1q__sectionHead",
  "site": "public-site-module__XXtH1q__site",
  "skillSteps": "public-site-module__XXtH1q__skillSteps",
  "sourceSurface": "public-site-module__XXtH1q__sourceSurface",
  "srOnly": "public-site-module__XXtH1q__srOnly",
  "statusDot": "public-site-module__XXtH1q__statusDot",
  "step": "public-site-module__XXtH1q__step",
  "stepNumber": "public-site-module__XXtH1q__stepNumber",
  "support": "public-site-module__XXtH1q__support",
  "tabs": "public-site-module__XXtH1q__tabs",
  "textLink": "public-site-module__XXtH1q__textLink",
  "threeColumns": "public-site-module__XXtH1q__threeColumns",
  "twoColumns": "public-site-module__XXtH1q__twoColumns",
  "unavailable": "public-site-module__XXtH1q__unavailable",
});
